import React from 'react';
import { IStorefrontBundle } from '../../Api/Models/Products';
import BundleCard from '../Cards/BundleCard';

interface IFeaturedBundlesDisplayProps {
    bundles: IStorefrontBundle[];
    showAddToCart?: boolean;
}

const FeaturedBundlesDisplay: React.FC<IFeaturedBundlesDisplayProps> = (props) => {
    return (
        <div style={{marginBottom: '1em'}}>
            <div className={'card-container'}>
                {props.bundles.map((bundle) => (
                    <BundleCard
                            key={bundle.id}
                            bundle={bundle}
                            showAddToCart={props.showAddToCart}
                    />
                ))}
            </div>
        </div>
    );
}

export default FeaturedBundlesDisplay;